import { take, fork, select, put, call, delay } from 'redux-saga/effects';
import actionTypes from '../actionTypes';
import { callApi } from "./callApi";
import config from '../../config/config';
import axios from 'axios';
import { getGlobalAccount, getGlobalToken, getOwnAccounts, getAccountAvatars } from '../selectors';
import {
    successAvatarMenu,
    successSetAvatar,
    successAvatars,
    avatarJSONSuccess,
    avatarJSONFailure,
} from "../actionCreators/avatar";
import {showNotification} from "../actionCreators/notification";

const removeUrlLastPart = url => {
    let arr = url.split('/');
    arr.pop();
    return arr.join('/');
}

function* getAvatarMenu() {
    try {
        const token = yield select(getGlobalToken);
        const response = yield call(callApi, `${config.API_MEDIA_URL}/getAvatarMenu`, 'GET', { token });

        const jsonUrls = response.data.result.avatarMenu;
        const avatarMenu = [];
        for (let jsonUrl of jsonUrls) {
            axios.get(jsonUrl).then(response => {
                const jsonContent = response.data;
                jsonContent.imageUrl = removeUrlLastPart(jsonUrl) + '/' + jsonContent.image;
                jsonContent.jsonUrl = jsonUrl;
                avatarMenu.push(jsonContent);
            });
        }

        yield put(successAvatarMenu(avatarMenu));
    } catch (e) {}
}

function* getJSON(path) {
  try {
    const response = yield call(callApi, path, 'GET', {});
    yield put(avatarJSONSuccess(path, response.data));
  } catch (e) {
    yield put(avatarJSONFailure(path, e));
  }
}

const requestedJSONs = [];
const requestedAvatars = [];

const jsonTest = /\.json$/i;

function* getAvatars(accounts) {
    try {
        const token = yield select(getGlobalToken);
        const missing = accounts.filter(aid => requestedAvatars.indexOf(aid) === -1);
        if (!missing.length) return;
        requestedAvatars.push(...missing);
        const response = yield call(
            callApi,
            `${config.API_MEDIA_URL}/getAvatars`,
            'GET',
            { token, accounts: missing },
        );
        const { avatars } = response.data.result;
        yield put(successAvatars(avatars));

        const jsons = Object.values(avatars)
            .filter(a => jsonTest.test(a.imagePath))
            .map(a => a.imagePath)
            .filter(p => requestedJSONs.indexOf(p) === -1);
        requestedJSONs.push(...jsons);
        for (let i = 0, l = jsons.length; i < l; i += 1) yield fork(getJSON, jsons[i]);
    } catch (e) {}
}

function* setProfileAvatar({ name, imagePath }) {
    try {
        const { id: accountId, token } = yield select(getGlobalAccount);
        const params = { name, imagePath, token };
        requestedAvatars.splice(requestedAvatars.indexOf(accountId),1)
        yield call(callApi, `${config.API_MEDIA_URL}/setAvatar`, 'POST', params);
        yield put(successSetAvatar({ accountId }));
    } catch (e) {}
}

export function* watchSetAvatar() {
    while (true) {
        const action = yield take(actionTypes.SET_PROFILE_AVATAR_REQUEST);
        yield fork(setProfileAvatar, action);
    }
}

export function* watchAvatarMenu() {
    while (true) {
        yield take(actionTypes.AVATAR_MENU_REQUEST);
        yield fork(getAvatarMenu);
    }
}

const avatarExtractFns = {
    [actionTypes.CLUBS_SUCCESS]: (a) => a.clubsData.map(acc => acc.clubId),
    [actionTypes.CURRENT_CLUB_MEMBERS_SUCCESS]: (a) => a.members.map(mbr => mbr._id),
    [actionTypes.LEADERBOARD_SUCCESS]: (a) => a.leaderboard.map(pl => pl._id),
    [actionTypes.GLOBALACCOUNT_SUCCESS]: (a) => [a.globalAccountIn.id],
    [actionTypes.CHANGE_CLUB_SUCCESS]: (a) => [a.clubId],
    [actionTypes.SET_PROFILE_AVATAR_SUCCESS]: (a) => [a.accountId],
    [actionTypes.AVATARS_REQUEST]: (a) => a.accountList,
    [actionTypes.CLUB_DATA_SUCCESS]: (a) => a.data && a.data.playerWinLoss && a.data.playerWinLoss.length ? a.data.playerWinLoss.map(acc => acc.accountId) : [],
    [actionTypes.UNION_PENDINGS_SUCCESS]: (a) => a.clubs.map(acc => acc.accountId),
    [actionTypes.UNION_MEMBERS_SUCCESS]: (a) => a.clubs.map(acc => acc._id),
};

export function* watchAvatarActions() {
    const avatarActionTypes = Object.keys(avatarExtractFns);
    console.log('avatarActionTypes = ', avatarActionTypes);
    while (true) {
        const action = yield take(avatarActionTypes);
        const ids = avatarExtractFns[action.type](action);
        yield fork(getAvatars, ids);
    }
}
